import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

export const getApiKeyListAsync = createAsyncThunk(
  'api/getApiKeyListAsync',
  async (request: IApiKeyListParams, { rejectWithValue, dispatch }) => {
    const { applicationId, query } = request;
    const searchQuery: Record<string, string> = {
      populate: 'privateDb,clusterDb',
      'pagination[page]': query.page ?? Value.TABLE_PAGE_INIT,
      'pagination[pageSize]': query.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (query.apiKey) searchQuery['filters[apiKey][$contains]'] = query.apiKey;
    if (query.disabled) searchQuery['filters[disabled][$eq]'] = query.disabled;

    const params = new URLSearchParams(searchQuery).toString();
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IListRes<IApiKeyDetailRes>>(
        Enums.HTTP_METHOD.GET,
        Paths.API_KEY.replace(':id', String(applicationId)) + '?' + params,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const disableApiKeyAsync = createAsyncThunk(
  'api/disableApiKeyAsync',
  async (data: IDisableApiKeyQuery, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { applicationId, apiKey } = data;
    try {
      const { data } = await axios.request(
        Enums.HTTP_METHOD.PATCH,
        Paths.UPDATE_API_KEY.replace(':id', applicationId).replace(
          ':key',
          apiKey,
        ),
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const createApiKeyAsync = createAsyncThunk(
  'api/createApiKeyAsync',
  async (data: ICreateApiKey, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    const { applicationId, apiNames } = data;
    try {
      const { data } = await axios.request<ICreateApiKeyRes>(
        Enums.HTTP_METHOD.POST,
        Paths.API_KEY.replace(':id', applicationId),
        {
          apiNames,
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);

export const getServiceListAsync = createAsyncThunk(
  'api/getServiceListAsync',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const { data } = await axios.request<IDataRes<IServiceListRes[]>>(
        Enums.HTTP_METHOD.GET,
        Paths.SERVICE_LIST,
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
